var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1042,
    height: 191,
    viewBox: "0 0 1042 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H162.726C170.216 1 176.287 7.07126 176.287 14.5605V69.6502C176.287 77.1395 182.358 83.2108 189.848 83.2108H744.982C752.471 83.2108 758.543 89.282 758.543 96.7713V176.439C758.543 183.929 764.614 190 772.103 190H1041.62",
    stroke: "url(#paint0_radial_814_1223)",
    strokeWidth: 1.69507
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H162.726C170.216 1 176.287 7.07126 176.287 14.5605V69.6502C176.287 77.1395 182.358 83.2108 189.848 83.2108H744.982C752.471 83.2108 758.543 89.282 758.543 96.7713V176.439C758.543 183.929 764.614 190 772.103 190H1041.62",
    stroke: "url(#paint1_radial_814_1223)",
    strokeWidth: 1.69507
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_814_1223",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(520.386 74.7355) scale(456.821 1025.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13161B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_814_1223",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(520.386 74.7355) scale(456.821 1025.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13161B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.0ec0eaf1bdab291d2097698d9d2100af.svg";
export { ForwardRef as ReactComponent };